import { API } from 'common';
import QueryString from 'utils/queryString';

const getCategories = () => API.get(`service/category/list`);

const getServices = () => API.get(`service/list`);

const getStaffs = () => API.get(`staff/list`);

const getStaffAvailable = (params: Record<string, unknown>) => API.get(`appointment/staff-available-booking?${QueryString.stringify(params)}`);

const shopInfo = () => API.get('shop/detail');

const allBannerByShop = () => API.get('shop/info');

// phone may be undefined: one call site passes Cookies.get() unguarded, which
// requests .../undefined — pre-existing behavior, modeled honestly rather than asserted
const staffShopsByPhone = (phone: string | undefined) => API.get('staff/sign-in-by-phone/' + phone);

const shopApis = {
  getStaffs,
  getCategories,
  getServices,
  shopInfo,
  allBannerByShop,
  staffShopsByPhone,
  getStaffAvailable,
};

export default shopApis;
